// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StatsCard_wrapper__BI6zT","title":"StatsCard_title__tYaL7","cards":"StatsCard_cards__zThPH","hide":"StatsCard_hide__TJHrC"};